import ApiConfig from "../../Utils/Configs/apiConfig";

interface EditClientPayload {
  clientId: string;
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  adminId: string;
}

export const editClientApi = async (payload: EditClientPayload) => {
  try {
    const response = await ApiConfig.getInstance().put("/Account/edit-client", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error editing client:", error);
    throw error.response?.data || error.message;
  }
};